import { queryClient } from '~/utils/queryClient';

import { getStorefrontUrl } from './getStorefrontUrl';

export default async function fetcher<T>(url: string): Promise<T> {
  const token = queryClient.getQueryData<string>(['token']);

  const headers = new Headers({});
  headers.set('Authorization', `Bearer ${token}`);

  const absoluteUrl = url.startsWith('http') ? url : getStorefrontUrl(url).toString();

  const response = await fetch(absoluteUrl, { headers });

  if (!response.ok) {
    switch (response.status) {
      case 400:
        throw new Error('Bad Request');
      case 401:
        queryClient.invalidateQueries({ queryKey: ['token'] });
        throw new Error('Unauthorized');
      case 404:
        throw new Error('Not Found');
      default:
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
  }

  const contentType = response.headers.get('content-type');
  if (!contentType || !contentType.includes('application/json')) {
    await response.text();
    throw new Error(`Expected JSON response but received ${contentType || 'unknown content type'}`);
  }

  try {
    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(
      `Failed to parse JSON response: ${error instanceof Error ? error.message : 'Unknown error'}`,
    );
  }
}
